import { getIsMtoAvailable } from '@ms/yammer-data/dist/domains/multiTenantOrganizationDetails/selectors';
import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useSelector } from '../useSelector';

type UseMtoEnabled = () => boolean;
export const useMtoEnabled: UseMtoEnabled = () => {
  const isVivaEngagePremiumEnabled = useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium) === true;
  const isMtoEnabled = useExperimentTreatmentWithoutReporting(Experiment.MultiTenantOrganization) === true;

  return isVivaEngagePremiumEnabled && isMtoEnabled;
};

type UseMtoEnabledAndAvailable = () => boolean;
export const useMtoEnabledAndAvailable: UseMtoEnabledAndAvailable = () => {
  const isMtoAvailable = useSelector((state) => getIsMtoAvailable(state));
  const isMtoEnabled = useMtoEnabled();

  return isMtoAvailable && isMtoEnabled;
};
